import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputAdornment from '@material-ui/core/InputAdornment'
import CalendarToday from '@material-ui/icons/CalendarToday'
import MaskedInput from 'react-text-mask'
import { withTranslate } from 'react-redux-multilingual'
import { connect } from 'react-redux'
import { compose } from 'redux'

import Autocomplete from '@material-ui/lab/Autocomplete'
import Places from '../modules/places'
import FormSelect from './booking-info/FormSelect'

const TRANSPORT_METHODS = [
  { value: 'airplane', labelKey: 'transportMethodAirplane' },
  { value: 'bus',      labelKey: 'transportMethodBus' },
  { value: 'car',      labelKey: 'transportMethodCar' },
  { value: 'ship',     labelKey: 'transportMethodShip' },
  { value: 'train',    labelKey: 'transportMethodTrain' },
  { value: 'other',    labelKey: 'transportMethodOther' }
]

class BookingInfoQuestion extends React.Component {
  state = {
    places1: [],
    places2: []
  }

  _findPlace1InProgress = false
  _findPlace2InProgress = false

  constructor(props) {
    super(props)
    this.DateFormatCustom = this.DateFormatCustom.bind(this)
  }

  DateFormatCustom(props) {
    const { inputRef, ...other } = props
    return (
      <MaskedInput
        {...other}
        mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
        ref={(ref) => {
          inputRef(ref ? ref.inputElement : null)
        }}
        placeholder={this.props.translate('dateformat')}
        placeholderChar={' '}
      />
    )
  }

  handleChangeFindPlace1 = async (event) => {
    const value = event.target.value
    if (value.length < 3) {
      this.setState({ places1: [] })
      return
    }
    if (this._findPlace1InProgress) return

    this._findPlace1InProgress = true
    try {
      const response = await Places.findPlace(value)
      if (response.status === true) {
        this.setState({ places1: response.result.places })
      }
    } finally {
      this._findPlace1InProgress = false
    }
  }

  handleChangeSelectPlace1 = (place) => {
    if (place !== null) {
      this.props.setCheckinField('q1_origin', place.id)
    }
  }

  handleChangeFindPlace2 = async (event) => {
    const value = event.target.value
    if (value.length < 3) {
      this.setState({ places2: [] })
      return
    }
    if (this._findPlace2InProgress) return

    this._findPlace2InProgress = true
    try {
      const response = await Places.findPlace(value)
      if (response.status === true) {
        this.setState({ places2: response.result.places })
      }
    } finally {
      this._findPlace2InProgress = false
    }
  }

  handleChangeSelectPlace2 = (place) => {
    if (place !== null) {
      this.props.setCheckinField('q2_destination', place.id)
    }
  }

  render() {
    const { classes, translate, checkinFieldsBehaviour: fields } = this.props

    return (
      <React.Fragment>
        <Grid container className={classes.root}>
          <Typography variant="h6" gutterBottom className={classes.heading}>
            {translate('moreAboutYouLabel')}
          </Typography>

          {fields.filter((e) => e.field === 'q1_origin')[0].visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <Autocomplete
                id="q1_origin"
                style={{ width: '100%' }}
                margin="normal"
                required={
                  this.props.checkinFieldsBehaviour.filter(
                    (e) => e.field === 'q1_origin'
                  )[0].required
                }
                label={translate('question1Label')}
                options={this.state.places1}
                onChange={(a, b) => this.handleChangeSelectPlace1(b)}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.place_name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={translate('question1Label')}
                    onChange={this.handleChangeFindPlace1}
                    fullWidth
                  />
                )}
              />
              <FormHelperText id={classes.errorText}>
                {this.props.checkinFieldsBehaviour.filter(
                  (e) => e.field === 'q1_origin'
                )[0].required &&
                !this.props.valid &&
                this.props.checkin.q1_origin === ''
                  ? translate('questionHelperText')
                  : ''}
              </FormHelperText>
            </Grid>
          )}
          {fields.filter((e) => e.field === 'q2_destination')[0].visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <Autocomplete
                id="q2_destination"
                style={{ width: '100%' }}
                margin="normal"
                label={translate('question2Label')}
                required={
                  this.props.checkinFieldsBehaviour.filter(
                    (e) => e.field === 'q2_destination'
                  )[0].required
                }
                options={this.state.places2}
                onChange={(a, b) => this.handleChangeSelectPlace2(b)}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.place_name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={translate('question2Label')}
                    onChange={this.handleChangeFindPlace2}
                    fullWidth
                  />
                )}
              />
              <FormHelperText id={classes.errorText}>
                {this.props.checkinFieldsBehaviour.filter(
                  (e) => e.field === 'q2_destination'
                )[0].required &&
                !this.props.valid &&
                this.props.checkin.q2_destination === ''
                  ? translate('questionHelperText')
                  : ''}
              </FormHelperText>
            </Grid>
          )}

          {(() => {
            const q3 = fields.find((e) => e.field === 'q3_trip_motivation') || {}
            const required = q3.required
            const value = this.props.checkin.q3_trip_motivation
            return (
              <FormSelect
                visible={q3.visible}
                required={required}
                error={required && this.props.valid === false && value === ''}
                errorText={translate('questionHelperText')}
                id="q3-required"
                name="q3_trip_motivation"
                label={translate('question3Label')}
                value={value}
                onChange={this.props.handleChange}
                options={this.props.questions1.map((q) => ({ value: q.id, label: q.desc }))}
                outerClassName={classes.gridItemClasses}
                gridSm={12}
              />
            )
          })()}

          {(() => {
            const q4 = fields.find((e) => e.field === 'q4_property_choose_motivation') || {}
            const required = q4.required
            const value = this.props.checkin.q4_property_choose_motivation
            return (
              <FormSelect
                visible={q4.visible}
                required={required}
                error={required && this.props.valid === false && value === ''}
                errorText={translate('questionHelperText')}
                id="q4-required"
                name="q4_property_choose_motivation"
                label={translate('question4Label')}
                value={value}
                onChange={this.props.handleChange}
                options={this.props.questions2.map((q) => ({ value: q.id, label: q.desc }))}
                outerClassName={classes.gridItemClasses}
                gridSm={12}
              />
            )
          })()}

          {fields.filter((e) => e.field === 'country_entry_date')[0] &&
            fields.filter((e) => e.field === 'country_entry_date')[0].visible && (
              <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
                <TextField
                  id="country_entry_date"
                  name="country_entry_date"
                  label={translate('countryEntryDateLabel')}
                  placeholder="dd/MM/yyyy"
                  value={this.props.checkin.country_entry_date || ''}
                  onChange={this.props.handleChangeTF('country_entry_date')}
                  fullWidth
                  required={fields.filter((e) => e.field === 'country_entry_date')[0].required}
                  error={
                    fields.filter((e) => e.field === 'country_entry_date')[0].required &&
                    this.props.valid === false &&
                    !this.props.checkin.country_entry_date
                  }
                  helperText={
                    fields.filter((e) => e.field === 'country_entry_date')[0].required &&
                    !this.props.valid &&
                    !this.props.checkin.country_entry_date
                      ? translate('countryEntryDateHelperText')
                      : ''
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CalendarToday />
                      </InputAdornment>
                    ),
                    inputComponent: this.DateFormatCustom
                  }}
                />
              </Grid>
            )}

          {(() => {
            const config = fields.find((e) => e.field === 'transport_method')
            if (!config) return null
            const required = config.required
            const value = this.props.checkin.transport_method
            return (
              <FormSelect
                visible={config.visible}
                required={required}
                error={required && this.props.valid === false && value === ''}
                errorText={translate('transportMethodHelperText')}
                id="transport-method-required"
                name="transport_method"
                label={translate('transportMethodLabel')}
                value={value}
                onChange={this.props.handleChange}
                options={TRANSPORT_METHODS.map((m) => ({
                  value: m.value,
                  label: translate(m.labelKey)
                }))}
                outerClassName={classes.gridItemClasses}
              />
            )
          })()}

          {parseInt(this.props.checkinAdditionalField[0].active) === 1 && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={12}>
              <Typography variant="h6" className={classes.heading}>
                <small>
                  {this.props.checkinAdditionalField[0].label === '' ? translate(`additionalFieldLabel`) : this.props.checkinAdditionalField[0].label}
                </small>
              </Typography>
              <TextField
                multiline
                minRows={8}
                id={'additional_info'}
                name={'additional_info'}
                value={this.props.checkin['additional_info'] || ''}
                onChange={this.props.handleChangeTF('additional_info')}
                className={classes.inputField}
                fullWidth
              />
            </Grid>
          )}

          <Grid item className={classes.gridItemClasses} xs={12}>
            <FormControlLabel
              onChange={this.props.seeTerms()}
              control={
                <Checkbox color="secondary" name="acceptTerms" value="yes" />
              }
              label={translate('acceptTermsLabel')}
            />
            <FormHelperText>
              {!this.props.valid && !this.props.terms_accepted ? translate('acceptTermsHelperText') : ''}
            </FormHelperText>
          </Grid>
        </Grid>
      </React.Fragment>
    )
  }
}

const styles = (theme) => ({
  DateFormatInput: {
    '& div div': {
      height: '31px'
    }
  },
  gridItemClasses: {
    paddingTop: 15,
    paddingBottom: 15
  },
  cssUnderline: {
    '&:after': {
      borderBottomColor: '#f2994a'
    }
  },
  heading: {
    color: theme.palette.text.secondary,
    width: '100%',
    fontSize: theme.typography.pxToRem(15),
    paddingTop: '24px'
  },
  inputField: {
    marginTop: 15
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative'
  },
  root: {
    padding: 20,
    [theme.breakpoints.down('md')]: {
      minWidth: '100%'
    }
  },
  button: {
    float: 'right'
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1)
  },
  suggestion: {
    display: 'block'
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none'
  },
  divider: {
    height: theme.spacing(2)
  },
  errorText: {
    color: '#f44336'
  }
})

BookingInfoQuestion.propTypes = {
  classes: PropTypes.object.isRequired
}

export default compose(
  withStyles(styles),
  connect()
)(withTranslate(BookingInfoQuestion))
